<div class="popover-container">
  <div class="popover" #popover>
    <ng-content></ng-content>
  </div>
</div>
